<template>
  <div class="container mt-4">
    <h3 class="text-primary">
      <i class="fa fa-user-circle me-2"></i>
      {{ $t("dashboard.accountInfo") }}
    </h3>
    
    <p class="text-muted">{{ $t("dashboard.info") }}</p>
<!-- Lista de clienți -->
<div class="card p-4 shadow mb-4">
  <h4 class="text-primary">
    <i class="fa fa-users me-2"></i>
    {{ $t("dashboard.clientList") }}
  </h4>

  <div v-if="loading" class="text-center my-5">
    <i class="fa fa-spinner fa-spin fa-2x"></i>
  </div>

<!-- Tabel Clienți Responsive -->
<div class="table-responsive" v-if="clients.length">
  <table class="table table-hover mt-3 rounded">
    <thead class="bg-primary text-white">
      <tr class="text-center">
        <th>#</th>
        <th>{{ $t("dashboard.fullName") }}</th>
        <th>{{ $t("dashboard.cui") }}</th>
        <th>{{ $t("dashboard.country") }}</th>
        <th>{{ $t("dashboard.actions") }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(client, index) in clients" :key="client.id" class="text-center">
        <td>{{ index + 1 }}</td>
        <td>{{ client.denumire }}</td>
        <td>{{ client.cod_fiscal }}</td>
        <td>{{ client.tara }}</td>
        <td>
          <button class="btn btn-sm btn-danger" @click="deleteClient(client.id)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>


  <p v-if="!clients.length && !loading" class="text-muted">
    {{ $t("dashboard.noClients") }}
  </p>
</div>

<!-- Căutare client existent după CUI -->
<div class="card p-4 shadow mb-4">
  <h4 class="text-primary"><i class="fa fa-search me-2"></i>{{ $t("dashboard.searchClient") }}</h4>
  <form @submit.prevent="searchClientByCUI">
    <div class="mb-3">
      <label class="form-label"><i class="fa fa-id-card me-2"></i>{{ $t("dashboard.cui") }}</label>
      <input type="text" v-model="searchCUI" class="form-control" required />
    </div>
    <button type="submit" class="btn btn-primary w-100">
      <i class="fa fa-search me-2"></i>{{ $t("dashboard.searchButton") }}
    </button>
  </form>

  <p v-if="clientFound" class="text-success mt-2">
    <i class="fa fa-check-circle"></i> {{ $t("dashboard.clientFound") }}
  </p>

  <button
    v-if="clientFound"
    @click="associateClient"
    class="btn btn-success mt-2 w-100"
  >
    <i class="fa fa-link me-2"></i> {{ $t("dashboard.associateClient") }}
  </button>

  <p v-if="clientError" class="text-danger mt-2">
    <i class="fa fa-exclamation-circle"></i> {{ $t("dashboard.clientNotFound") }}
  </p>
</div>


    <!-- Adăugare client nou -->
    <div class="card p-4 shadow mb-4" v-if="!clientFound">
      <h4 class="text-primary"><i class="fa fa-user-plus me-2"></i>{{ $t("dashboard.addNewClient") }}</h4>
      <form @submit.prevent="addNewClient">
        <div class="mb-3">
          <label class="form-label"><i class="fa fa-users me-2"></i>{{ $t("dashboard.clientType") }}</label>
          <select v-model="newClient.tip_client" class="form-select" required>
            <option value="PJ">{{ $t("dashboard.company") }}</option>
            <option value="PF">{{ $t("dashboard.individual") }}</option>
          </select>
        </div>

        <div class="mb-3">
          <label class="form-label"><i class="fa fa-id-card me-2"></i>{{ newClient.tip_client === 'PJ' ? $t("dashboard.cui") : $t("dashboard.cnp") }}</label>
<input
  type="text"
  v-model="newClient.cod_fiscal"
  class="form-control"
  :required="newClient.tip_client === 'PJ'"
/>

        </div>

        <div class="mb-3">
          <label class="form-label"><i class="fa fa-user me-2"></i>{{ $t("dashboard.fullName") }}</label>
          <input type="text" v-model="newClient.denumire" class="form-control" required />
        </div>

<div class="mb-3">
  <label class="form-label"><i class="fa fa-flag me-2"></i>{{ $t("dashboard.country") }}</label>
<v-select
  v-model="selectedCountry"
  :options="countriesLocalized"
  label="name"
  :reduce="c => c" 
  :placeholder="$t('dashboard.selectCountry')"
/>



</div>


<div class="mb-3" v-if="romaniaSelected">
  <label class="form-label"><i class="fa fa-map me-2"></i>{{ $t("dashboard.county") }}</label>
  <v-select
    v-model="newClient.judet"
    :options="judeteArray"
    :placeholder="$t('dashboard.selectCounty')"
  />
</div>



<div class="mb-3">
  <label class="form-label"><i class="fa fa-location-arrow me-2"></i>
    {{ newClient.judet === 'București' ? 'Sector București' : $t("dashboard.city") }}
  </label>
  <template v-if="newClient.judet === 'București'">
    <v-select
      :options="sectorsBucuresti"
      v-model="newClient.localitate"
      placeholder="Selectează sectorul"
    />
  </template>
  <template v-else>
    <input type="text" v-model="newClient.localitate" class="form-control" />
  </template>
</div>


        <div class="mb-3">
          <label class="form-label"><i class="fa fa-home me-2"></i>{{ $t("dashboard.address") }}</label>
          <input type="text" v-model="newClient.adresa" class="form-control" required  />
        </div>

        <div class="mb-3">
          <label class="form-label"><i class="fa fa-envelope me-2"></i>{{ $t("dashboard.emailBilling") }}</label>
          <input type="email" v-model="newClient.email" class="form-control" />
        </div>

        <div class="mb-3" v-if="newClient.tip_client === 'PJ'">
          <label class="form-label"><i class="fa fa-building me-2"></i>{{ $t("dashboard.registrationNumber") }}</label>
          <input type="text" v-model="newClient.nr_reg_com" class="form-control" />
        </div>

        <button type="submit" class="btn btn-primary w-100">
          <i class="fa fa-save me-2"></i>{{ $t("dashboard.saveButton") }}
        </button>
      </form>
    </div>

    <!-- Actualizare parolă și email -->
    <div class="card p-4 shadow">
      <h4><i class="fa fa-lock me-2"></i> {{ $t("dashboard.updateCredentials") }}</h4>
      <form @submit.prevent="updateCredentials">
        <div class="mb-3">
          <label class="form-label"><i class="fa fa-envelope me-2"></i>{{ $t("dashboard.email") }}</label>
          <input type="email" v-model="credentials.email" class="form-control" />
        </div>
        <div class="mb-3">
          <label class="form-label"><i class="fa fa-key me-2"></i>{{ $t("dashboard.oldPassword") }}</label>
          <input type="password" v-model="credentials.old_password" class="form-control" />
        </div>
        <div class="mb-3">
          <label class="form-label"><i class="fa fa-lock me-2"></i>{{ $t("dashboard.newPassword") }}</label>
          <input type="password" v-model="credentials.new_password" class="form-control" />
        </div>
        <button type="submit" class="btn btn-primary w-100">
          <i class="fa fa-save me-2"></i> {{ $t("dashboard.updateCredentialsButton") }}
        </button>
      </form>
    </div>
  </div>
</template>
<script>
import countriesRO from "@/locales/countries_ro.json";
import countriesEN from "@/locales/countries_en.json";
import countriesBG from "@/locales/countries_bg.json";
import vSelect from "vue3-select";
import "vue3-select/dist/vue3-select.css";
import Swal from 'sweetalert2';
import axios from 'axios';

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      searchCUI: "",
      clients: [],
      loading: false,
      clientFound: false,
      clientError: "",
      selectedCountry: null,
      sectorsBucuresti: ["SECTOR1", "SECTOR2", "SECTOR3", "SECTOR4", "SECTOR5", "SECTOR6"],
      newClient: {
        tip_client: "",
        cod_fiscal: "",
        denumire: "",
        tara: "", // codul ISO, ex: "RO"
        judet: "",
        localitate: "",
        adresa: "",
        email: "",
        nr_reg_com: "",
      },
      allCountries: {
        ro: countriesRO,
        en: countriesEN,
        bg: countriesBG,
      },
      credentials: {
        email: "",
        old_password: "",
        new_password: "",
      },
      judete: {
        "AB": "Alba", "AR": "Arad", "AG": "Argeș", "BC": "Bacău", "BH": "Bihor", "BN": "Bistrița-Năsăud",
        "BR": "Brăila", "BT": "Botoșani", "BV": "Brașov", "BZ": "Buzău", "CS": "Caraș-Severin", "CL": "Călărași",
        "CJ": "Cluj", "CT": "Constanța", "CV": "Covasna", "DB": "Dâmbovița", "DJ": "Dolj", "GL": "Galați",
        "GR": "Giurgiu", "GJ": "Gorj", "HR": "Harghita", "HD": "Hunedoara", "IL": "Ialomița", "IS": "Iași",
        "IF": "Ilfov", "MM": "Maramureș", "MH": "Mehedinți", "MS": "Mureș", "NT": "Neamț", "OT": "Olt",
        "PH": "Prahova", "SM": "Satu Mare", "SJ": "Sălaj", "SB": "Sibiu", "SV": "Suceava", "TR": "Teleorman",
        "TM": "Timiș", "TL": "Tulcea", "VS": "Vaslui", "VL": "Vâlcea", "VN": "Vrancea", "B": "București"
      },
      credentialsSuccess: "",
      credentialsError: "",
    };
  },

  computed: {
romaniaSelected() {
  return this.selectedCountry?.code === 'RO';
}

,
    countriesLocalized() {
      const currentLang = this.$i18n.locale;
      const fallback = countriesRO;
      const list = this.allCountries[currentLang] || fallback;

      return list.map(c => ({
        code: c.code,
        name: c[`name_${currentLang}`] || c.name_ro,
      }));
    },
    judeteArray() {
      return Object.values(this.judete);
    },
    taraSelectata() {
      const ro = this.allCountries.ro.find(c => c.code === this.newClient.tara);
      return ro?.name_ro || "";
    },
  },

watch: {
  selectedCountry(newVal) {
    this.newClient.tara = newVal?.code || '';
    console.log("🟡 Țară selectată:", newVal);
    if (newVal?.code === 'RO') {
      // Dacă județul e gol, selectăm implicit București
      if (!this.newClient.judet) {
        this.newClient.judet = 'București';
      }
    } else {
      // Dacă se schimbă în altă țară, ștergem județul
      this.newClient.judet = '';
    }
  },
}
,

mounted() {
  this.fetchClients();

  if (!this.selectedCountry && !this.newClient.tara) {
    const ro = this.countriesLocalized.find(c => c.code === 'RO');
    if (ro) {
      this.selectedCountry = ro;
    }
  }
}


,

  methods: {
    async fetchClients() {
      try {
        this.loading = true;
        const res = await axios.get("/list_clients", { withCredentials: true });
        this.clients = res.data.clients;
      } catch (err) {
        console.error("❌ Eroare la obținerea clienților:", err);
      } finally {
        this.loading = false;
      }
    },

    async deleteClient(id) {
      const result = await Swal.fire({
        title: this.$t("dashboard.confirmTitle"),
        text: this.$t("dashboard.confirmDelete"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        confirmButtonText: this.$t("dashboard.confirmYes"),
        cancelButtonText: this.$t("dashboard.confirmNo"),
      });

      if (result.isConfirmed) {
        try {
          await axios.delete(`/delete_client/${id}`, { withCredentials: true });
          this.clients = this.clients.filter(c => c.id !== id);
          Swal.fire({
            icon: "success",
            title: this.$t("dashboard.deleted"),
            text: this.$t("dashboard.deletedSuccess"),
            timer: 2000,
            showConfirmButton: false,
          });
        } catch (err) {
          console.error("❌ Eroare la ștergerea clientului:", err);
          Swal.fire({
            icon: "error",
            title: this.$t("dashboard.error"),
            text: this.$t("dashboard.deleteError"),
          });
        }
      }
    },

async searchClientByCUI() {
  try {
    const response = await axios.get(`/search_client_by_cui/${this.searchCUI}`, {
      withCredentials: true,
    });
    if (response.data.client) {
      this.clientFound = true;
      this.clientError = "";
      Swal.fire({
        icon: "success",
        title: this.$t("dashboard.clientFound"),
        text: `${response.data.client.denumire} a fost găsit.`,
        timer: 2000,
        showConfirmButton: false,
      });
    } else {
      this.clientFound = false;
      this.clientError = this.$t("dashboard.clientNotFound");
      Swal.fire({
        icon: "warning",
        title: this.$t("dashboard.clientNotFound"),
        text: "Verifică dacă ai introdus CUI-ul corect.",
        timer: 2000,
        showConfirmButton: false,
      });
    }
  } catch (error) {
    console.error("❌ Eroare la căutarea clientului:", error);
    this.clientFound = false;
    this.clientError = this.$t("dashboard.clientNotFound");
    Swal.fire({
      icon: "error",
      title: "Eroare",
      text: "A apărut o eroare la căutarea clientului.",
    });
  }
}
,

async addNewClient() {
  try {
    // 🔒 completare CNP dacă este PF și nu s-a completat
    if (this.newClient.tip_client === 'PF' && !this.newClient.cod_fiscal) {
      this.newClient.cod_fiscal = '0000000000000';
    }

    const payload = {
      ...this.newClient,
tara: {
  name_ro: this.selectedCountry?.name || this.selectedCountry?.name_ro || "",
  code: this.selectedCountry?.code || ""
}
    };

    await axios.post("/create_client/", payload, { withCredentials: true });

    this.clientFound = false;
    await this.fetchClients();

    Swal.fire({
      icon: "success",
      title: this.$t("dashboard.clientAdded"),
      text: "Clientul a fost adăugat cu succes.",
      timer: 2000,
      showConfirmButton: false,
    });
  } catch (error) {
    console.error("❌ Eroare la adăugarea clientului nou:", error);
    Swal.fire({
      icon: "error",
      title: this.$t("dashboard.error"),
      text: "Nu s-a putut adăuga clientul.",
    });
  }
}

,

async associateClient() {
  try {
    const res = await axios.post('/associate_client/', {
      cui: this.searchCUI,
    }, {
      withCredentials: true,
    });

    if (res.data.success) {
      this.clientFound = true;
      await this.fetchClients();
      Swal.fire({
        icon: "success",
        title: this.$t("dashboard.associateClient"),
        text: res.data.success,
        timer: 2000,
        showConfirmButton: false,
      });
    } else if (res.data.info) {
      // ✅ Cazul în care e deja asociat
      Swal.fire({
        icon: "info",
        title: this.$t("dashboard.clientAlreadyAssociated"),
        text: res.data.info,
        timer: 2000,
        showConfirmButton: false,
      });
    }

  } catch (err) {
    console.error("❌ Eroare la asocierea clientului:", err);
    Swal.fire({
      icon: "error",
      title: "Eroare",
      text: "A apărut o eroare la asocierea clientului.",
    });
  }
},

async updateCredentials() {
  try {
    await axios.put("/account/update_credentials/", this.credentials, {
      withCredentials: true,
    });
    this.credentialsSuccess = this.$t("dashboard.updateCredentialsSuccess");
    Swal.fire({
      icon: "success",
      title: this.$t("dashboard.success"),
      text: this.credentialsSuccess,
      timer: 2000,
      showConfirmButton: false,
    });
  } catch (error) {
    this.credentialsError = this.$t("dashboard.updateCredentialsError");
    Swal.fire({
      icon: "error",
      title: this.$t("dashboard.error"),
      text: this.credentialsError,
    });
  }
}
,
  },
};
</script>

<style scoped>
.table th, .table td {
  vertical-align: middle;
}
.card {
  background: white;
  color: black;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.alert-info {
  font-weight: bold;
  background: #e3f2fd;
  color: #007bff;
}

.btn-primary {
  background-color: #007bff;
  border: none;
}

.btn-primary:hover {
  background-color: #0056b3;
}
.table {
  border-radius: 8px;
  overflow: hidden;
  background: #f8f9fa;
}

.table thead {
  background-color: #007bff;
  color: white;
}

.table tbody tr:hover {
  background: rgba(0, 123, 255, 0.1);
}

.table td,
.table th {
  vertical-align: middle;
}

</style>
